import {
  BusinessKnowledge,
  ScheduleKnowledge,
  PaymentAndInsuranceKnowledge,
} from '@weave/schema-gen-ts/dist/schemas/ai-settings/v1/ai_settings.pb';
import {
  AirSettingsBusinessAddressSource,
  AirSettingsBusinessHoursSource,
  AirSettingsBusinessSource,
} from '@frontend/api-ai-settings';
import { Weekday } from '@frontend/api-schedule-availability';
import { i18next } from '@frontend/i18n';
import { NavigateArgs, StaticSettingsRoutes } from '@frontend/settings-routing';
import { BusinessHoursMap } from '../../../types/air-settings.types';

export const BusinessAddressSourceLabelMap: Record<AirSettingsBusinessAddressSource, string> = {
  ORGANIZATION_SETTINGS: i18next.t('Organization Settings > Business Verification > Legal Business Information', {
    ns: 'ai-receptionist-settings',
  }),
  BRAND: i18next.t('Brand > Location Address', { ns: 'ai-receptionist-settings' }),
  CUSTOM: i18next.t('Custom', { ns: 'ai-receptionist-settings' }),
};

export const BusinessAddressSourceLinkMap: Partial<
  Record<AirSettingsBusinessAddressSource, NavigateArgs<StaticSettingsRoutes>>
> = {
  ORGANIZATION_SETTINGS: { to: '/organization/business-verification' },
  BRAND: { to: '/brand' },
};

export const BusinessNameSourceLabelMap: Record<AirSettingsBusinessSource, string> = {
  IAM: i18next.t('Default Location Name', { ns: 'ai-receptionist-settings' }),
  ORGANIZATION_SETTINGS: i18next.t('Organization Settings > Business Verification > Legal Business Information', {
    ns: 'ai-receptionist-settings',
  }),
  BRAND: i18next.t('Brand > External Name', { ns: 'ai-receptionist-settings' }),
  CUSTOM: i18next.t('Custom', { ns: 'ai-receptionist-settings' }),
};

export const BusinessHoursSourceLabelMap: Record<AirSettingsBusinessHoursSource, string> = {
  CUSTOM: i18next.t('Custom', { ns: 'ai-receptionist-settings' }),
};

export const BusinessNameSourceLinkMap: Partial<Record<AirSettingsBusinessSource, NavigateArgs<StaticSettingsRoutes>>> =
  {
    ORGANIZATION_SETTINGS: { to: '/organization/business-verification' },
    BRAND: { to: '/brand' },
  };

export const DEFAULT_TIME_RANGE = { start: '09:00:00', end: '17:00:00' };

export const DEFAULT_BUSINESS_HOURS: BusinessHoursMap = {
  [Weekday.monday]: DEFAULT_TIME_RANGE,
  [Weekday.tuesday]: DEFAULT_TIME_RANGE,
  [Weekday.wednesday]: DEFAULT_TIME_RANGE,
  [Weekday.thursday]: DEFAULT_TIME_RANGE,
  [Weekday.friday]: DEFAULT_TIME_RANGE,
};

export const DEFAULT_BUSINESS_KNOWLEDGE_DATA: Partial<BusinessKnowledge> = {
  name: {},
  businessHours: {},
};

export const DEFAULT_SCHEDULE_KNOWLEDGE_DATA: ScheduleKnowledge = {
  cancellationPolicy: '',
};

export const DEFAULT_PAYMENT_KNOWLEDGE_DATA: PaymentAndInsuranceKnowledge = {
  paymentTypes: '',
  insuranceAcceptedInNetwork: [],
  insuranceAcceptedOutOfNetwork: [],
  insuranceNotAccepted: [],
};
